import { useContext } from "react"

import { DesignTokensEditorContext } from "~/pages/Brand/CommunicationStudio/DesignStudio/contexts/designTokenEditor/DesignTokensEditorContext"

export const useDesignTokenEditor = () => {
  const ctx = useContext(DesignTokensEditorContext)
  if (!ctx)
    throw new Error(
      "useDesignTokenEditor must be used inside DesignTokenEditorProvider"
    )
  return ctx
}
